import { doc, runTransaction, serverTimestamp, increment } from 'firebase/firestore';
import { db } from '../../config';
import { auditAction, auditResourceType, patternStatus } from '../../../../constants/enum';
import { recordClientAuditEvent } from '../../function/security/clientAuditEventFunction';

/**
 * 読取パターンを削除（論理削除のみ・Storageファイルは削除しない）
 * 運営スタッフが削除済みパターンを閲覧する際にファイルを参照できるようにするため、
 * StorageのsampleFiles/originalSampleFilesは物理削除しない。
 */
export const deletePattern = async (patternId: string): Promise<void> => {
  const patternRef = doc(db, 'patterns', patternId);

  await runTransaction(db, async transaction => {
    const patternDoc = await transaction.get(patternRef);
    if (!patternDoc.exists()) {
      throw new Error('読取パターンが見つかりません。');
    }

    const data = patternDoc.data();
    const companyId = data.company_id as string | undefined;

    transaction.update(patternRef, {
      status: patternStatus.deleted,
      updated_at: serverTimestamp(),
    });

    if (companyId) {
      const companyDocRef = doc(db, 'companies', companyId);
      transaction.update(companyDocRef, {
        current_pattern_count: increment(-1),
      });
    }
  });

  // 監査ログ（#2985）: パターン削除。fire-and-forget で主処理を遅らせない
  void recordClientAuditEvent({
    action: auditAction.delete,
    resource_type: auditResourceType.readPattern,
    resource_id: patternId,
  });
};
